<ng-container
  *ngIf="resumenDescuentosFacade.resumenDescuentos$ | async as resumen"
>
  <div class="form-group" *ngIf="resumen.descuentosAplicados.length > 0">
    <div class="row">
      <div class="col-6 text-secondary">Subtotal:</div>
      <div class="col-6 text-right text-sm-left text-secondary">
        {{ resumen.subTotal | currency: 'COP':'symbol-narrow':'0.0-0' }}
      </div>
    </div>
    <div *ngFor="let descuento of resumen.descuentosAplicados">
      <div class="row">
        <div class="col-6 text-secondary">
          {{ descuento.descripcion }} {{ descuento.porcentaje }}%:
        </div>
        <div class="col-6 text-right text-sm-left text-secondary">
          -
          {{
            descuento.totalDescuento | currency: 'COP':'symbol-narrow':'0.0-0'
          }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6 text-secondary">Total Descuentos:</div>
      <div class="col-6 text-right text-sm-left text-secondary">
        {{ resumen.totalDescuentos | currency: 'COP':'symbol-narrow':'0.0-0' }}
      </div>
    </div>
  </div>
</ng-container>
